<template>
    <newForm v-bind:title='$t("news_management.news")' className="col-xs-12">
        <div v-bind:class="[direction ? 'k-rtl' : '' ]">
            <grid v-bind:columns="columns"
                  v-bind:reloadGrid="reloadGrid"
                  dataSourceUrl="api/news/list"
                  v-bind:toolbar="toolbar"
                  hasPaging="true"
                  pagingType="numeric"
                  resizable="true"
                  selectable="false"
                  sortable="true"
                  editable="false">
            </grid>
        </div>
        <component v-show="showNewsModal"
                   :is="currentModalComponent"
                   v-bind:showNewsModal="showNewsModal"
                   v-bind:modalData="modalData">
        </component>
    </newForm>
</template>

<script  type="text/javascript">
    import NewForm from '../forms/newform/newForm.vue';
    import Grid from "../widgets/grid/grid.vue";
    import Helper from '../../assets/ts/helper';
    import ModalNews from './modals/ModalNews.vue';

    const helper = new Helper();

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                columns: [
                    { field: "Id", menu: false, hidden: true },
                    { field: "Title", title: i18n.$t("news_management.title"), menu: false, hidden: false, sortable: true },
                    { field: "CreateAt", title: i18n.$t("news_management.createdAt"), template: (data) => helper.formatDateTime(new Date(data.CreateAt)), menu: false, hidden: false, sortable: true }
                ],
                toolbar: this.buildToolbarItems(),
                reloadGrid: 0,
                modalData: {},
                currentModalComponent: "",
                showNewsModal: 0
            }
        },
        methods: {
            buildToolbarItems() {
                let mapping = (value) => {
                    let hasSubActions = Array.isArray(value.subActions);
                    return {
                        type: hasSubActions ? "splitButton" : "button",
                        text: (value.icon) ? `<i class="${value.icon} fa-fw fa-lg"></i> ${value.text}` : value.text,
                        enable: value.enable,
                        click: value.action,
                        imageUrl: value.image,
                        menuButtons: hasSubActions ? value.subActions.map(mapping) : undefined
                    }
                };
                return this.getActions().map(mapping);
            },
            getActions() {
                return [
                    {
                        key: "AddNews",
                        text: this.$t("news_management.add"),
                        icon: "far fa-plus-square",
                        action: (node, nodeData, selecteds) => {
                            this.modalData.isCreation = true;
                            this.currentModalComponent = "ModalNews";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showNewsModal++;
                        },
                        enable: true
                    },
                    {
                        key: "EditNews",
                        text: this.$t("edit"),
                        icon: "far fa-edit",
                        action: (node, nodeData, selecteds) => {
                            let dataItem = nodeData[0];
                            this.modalData.isCreation = false;
                            this.modalData.id = dataItem.Id;
                            this.currentModalComponent = "ModalNews";
                            this.modalData.callback = () => {
                                this.reLoadeData();
                            };
                            this.showNewsModal++;
                        },
                        enable: false
                    },
                    {
                        key: "DeleteNews",
                        text: this.$t("remove"),
                        icon: "far fa-trash-alt",
                        action: (node, nodeData, selecteds) => {
                            let dataItem = nodeData[0];
                            var id = dataItem.Id;

                            var that = this;

                            confirm(i18n.$t("are_you_sure"), {
                                yes: function () {
                                    var url = "api/news/delete/" + id;

                                    that.doAjaxRequest(url, {}, () => { that.reLoadeData(); }, () => { }, 'DELETE');
                                },
                                no: function () { }
                            });
                        },
                        enable: false
                    }
                ];
            },
            reLoadeData() {
                this.reloadGrid++;
            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",

                    contentType: "application/json;charset=utf-8"
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        mounted() {
        },
        created() {
            console.log('new main');
        },
        components: {
            NewForm,
            Grid,
            ModalNews
        }
    }

</script>
